import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, ReplaySubject } from 'rxjs';
import { ZpmTenantProxySettings } from '../../shared/models/generated/ziroModels';
import { Router } from '@angular/router';
import { map } from 'rxjs/operators';

@Injectable()
export class MicrosoftTenantProxyFeatureSettingsContext {
  private _http = inject(HttpClient);
  private _router = inject(Router);

  private _stateSource = new ReplaySubject<ZpmTenantProxySettings>(1);
  state$ = this._stateSource.asObservable();

  constructor() {
    this.refresh().subscribe();
  }

  refresh(): Observable<void> {
    const tenantId = this._extractTenantIdFromUrl();
    return this._get(tenantId).pipe(
      map((proxySettings) => {
        this._stateSource.next(proxySettings);
      }),
    );
  }

  private _get(tenantId: string): Observable<ZpmTenantProxySettings> {
    return this._http.get<ZpmTenantProxySettings>(
      `/services/microsoft/admin/tenants/${tenantId}/proxy-feature-settings`,
    );
  }

  private _extractTenantIdFromUrl(): string {
    const match = this._router.url.match(/\/tenants\/\d+\//)[0];
    return match.replaceAll('/', '').replace('tenants', '');
  }
}
